import { SectionHeading } from './SectionHeading'

const stack = [
  { label: '言語', items: 'TypeScript' },
  {
    label: 'バックエンド',
    items: 'Node.js, Hono, Next.js, REST API, Drizzle ORM, Prisma, Zod'
  },
  {
    label: 'フロントエンド',
    items: 'React, Next.js, Vite, Tailwind CSS, shadcn'
  },
  { label: 'インフラ', items: 'Google Cloud, Terraform, Docker' },
  { label: '決済', items: 'Stripe' },
  { label: 'テスト', items: '単体テスト, 統合テスト' },
  { label: 'バージョン管理', items: 'Git' },
  { label: 'AI', items: 'LLM / AIエージェント, ワークフロー設計' },
  { label: '開発手法', items: 'AI活用開発, 少人数での高速開発' }
]

export const Stack = () => {
  return (
    <section id="stack" className="py-12 border-t border-ink-100">
      <SectionHeading number="07" title="技術スタック" />
      <dl className="space-y-4">
        {stack.map(({ label, items }) => (
          <div
            key={label}
            className="grid gap-1 sm:grid-cols-[8rem_1fr] sm:gap-6"
          >
            <dt className="font-mono text-xs tracking-wider text-ink-600 pt-[3px]">
              {label}
            </dt>
            <dd className="text-base leading-[1.9] text-ink-800">{items}</dd>
          </div>
        ))}
      </dl>
    </section>
  )
}
